import ConfirmAndSendModal, {
    ConfirmAndSendModalProps,
} from '../presentational/ConfirmAndSendModal';

interface ConfirmAndSendModalContainerProps {
    selectedPayee: ConfirmAndSendModalProps['selectedPayee'];
    type: ConfirmAndSendModalProps['type'];
    isPosting: ConfirmAndSendModalProps['isPosting'];
    error: ConfirmAndSendModalProps['error'];
    form: {
        amount: ConfirmAndSendModalProps['amount'];
        paymentReference: ConfirmAndSendModalProps['paymentReference'];
        startOn: ConfirmAndSendModalProps['startOn'];
        endOn: ConfirmAndSendModalProps['endOn'];
        recurType: ConfirmAndSendModalProps['recurType'];
    };
    hideModal: () => void;
    handleSubmit: ConfirmAndSendModalProps['handleSubmit'];
}

const ConfirmAndSendModalContainer = ({
    selectedPayee,
    type,
    isPosting,
    error,
    form,
    hideModal,
    handleSubmit,
}: ConfirmAndSendModalContainerProps) => {
    const handleClose = () => hideModal();

    return (
        <ConfirmAndSendModal
            {...form}
            selectedPayee={selectedPayee}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            isPosting={isPosting}
            error={error}
            type={type}
        />
    );
};

export default ConfirmAndSendModalContainer;
